module.exports = __webpack_public_path__ + "img/investment-dd-l1.90131b31.svg";